import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kmc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) {
    const status = e?.response?.status;
    if (!e?.response) return "Unable to reach the server. Please check your connection and try again.";
    if ([502, 503, 504].includes(status)) return "The portal service is restarting — please retry in a few seconds.";
    if (status === 404) return "The service is temporarily unavailable. If the portal was just started or updated, please retry in a few seconds.";
    return e?.message || "Something went wrong. Please try again.";
  }
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  return String(d);
};

export default api;
